<template>
  <div class="common_group">
    <div class="title">
      <img src="@/assets/images/informationIcon.png">
      <span>
        {{ $t('industryReport.zdchqy.name') }}
      </span>
    </div>
    <commonTable ref="costAscriptionTable" :footer-cost="activityClassificationCode === 'AC_01' ? { label: $t('industryReport.zdchqy.hj'), val: total } : {}" />
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
export default {
  name: 'AttendMeetings',
  data () {
    return {
      total: 0
    };
  },
  props: {
    landingRegionList: {
      type: Array,
      default: () => []
    },
    activityClassificationCode: {
      type: String,
      default: ''
    }
  },
  components: {
    commonTable
  },
  watch: {
    landingRegionList: {
      deep: true,
      handler (val) {
        let totalNum = 0;
        if (val && val.length > 0) {
           val.forEach(item => {
           if (item.suggestedSessions) {
           totalNum += item.suggestedSessions;
          }
        });
        }
        this.total = totalNum;
    }
  }
  },
/**
* 组件挂载完成后调用的钩子函数
*
* 在组件挂载完成后，调用 loadTable 方法来加载表格数据
*/
  mounted () {
    this.loadTable();
  },
  methods: {
    loadTable () {
      let tableRow = new TableRow();
      // 区域名称
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.zdchqy.qymc'))
          ._data('regionName')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return row[column.property];
            }
          })
      );
      if (this.activityClassificationCode === 'AC_01') {
      // 建议场次
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.zdchqy.jycc'))
          ._data('suggestedSessions')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return row[column.property];
            }
          })
      );
      }
      let column = tableRow._cols();
      this.$nextTick(() => {
        if (this.$refs.costAscriptionTable) {
          this.$refs.costAscriptionTable.setColumn(column, {
            page: false
          });
          this.$refs.costAscriptionTable.loadStaticTable(this.landingRegionList);
        }
      });
    }
  }
};
</script>
